import { StyleSheet } from 'aphrodite';
import { brandPrimaryHover, brandSecondary, titles } from '../../../web/styles/colors';

// import { CssSelectors } from '../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	continueButton: {
		minWidth: '136px !important',
	},
	copyLinkButton: {
		border: `1px solid ${brandPrimaryHover}`,
		borderRadius: 3,
		display: 'inline-flex',
		justifyContent: 'center',
		margin: '0 8px',
		padding: '10px 20px',
		textDecoration: 'none !important',
	},
	dropdownTrigger: {
		minWidth: 350,
	},
	dropdownWrap: {
		marginBottom: 18,
		width: '100%',
	},
	footer: {
		alignItems: 'center',
		display: 'flex',
	},
	heading: {
		color: brandSecondary,
		fontSize: 18,
		margin: '19px 0 11px 0',
	},
	text: {
		color: titles,
		fontSize: 14,
		margin: '0 0 22px',
	},
	wrapper: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		padding: '0px 33px 20px',
	},
});
